import React, { useState } from "react";
import "./PAMMReferralTree.css";
import { ChevronDown, ChevronRight, Users, DollarSign, TrendingUp } from "lucide-react";

function PAMMReferralTree() {
  const [expandedNodes, setExpandedNodes] = useState(["node-1"]);

  const treeData = [
    {
      id: "node-1",
      name: "Master IB - John Doe",
      email: "john@example.com",
      totalReferrals: 25,
      totalInvestment: "$150,000",
      commission: "$3,500",
      level: 1,
      children: [
        {
          id: "node-1-1",
          name: "Sub IB - Alice Brown",
          email: "alice@example.com",
          totalReferrals: 10,
          totalInvestment: "$75,000",
          commission: "$1,200",
          level: 2,
          children: [
            { id: "node-1-1-1", name: "Client - Tom Wilson", email: "tom@example.com", totalReferrals: 0, totalInvestment: "$25,000", commission: "$0", level: 3, children: [] },
            { id: "node-1-1-2", name: "Client - Sara Lee", email: "sara@example.com", totalReferrals: 0, totalInvestment: "$15,000", commission: "$0", level: 3, children: [] },
          ],
        },
        {
          id: "node-1-2",
          name: "Sub IB - Bob Smith",
          email: "bob@example.com",
          totalReferrals: 8,
          totalInvestment: "$50,000",
          commission: "$800",
          level: 2,
          children: [
            { id: "node-1-2-1", name: "Client - Mike Chen", email: "mike@example.com", totalReferrals: 0, totalInvestment: "$20,000", commission: "$0", level: 3, children: [] },
          ],
        },
      ],
    },
    {
      id: "node-2",
      name: "Master IB - Jane Wilson",
      email: "jane@example.com",
      totalReferrals: 18,
      totalInvestment: "$120,000",
      commission: "$2,800",
      level: 1,
      children: [],
    },
  ];

  const toggleNode = (nodeId) => {
    setExpandedNodes((prev) =>
      prev.includes(nodeId)
        ? prev.filter((id) => id !== nodeId)
        : [...prev, nodeId]
    );
  };

  const renderTreeNode = (node, depth = 0) => {
    const isExpanded = expandedNodes.includes(node.id);
    const hasChildren = node.children && node.children.length > 0;

    return (
      <div key={node.id} className="tree-node" style={{ marginLeft: depth * 30 }}>
        <div className="node-content">
          <div className="node-toggle" onClick={() => hasChildren && toggleNode(node.id)}>
            {hasChildren ? (
              isExpanded ? <ChevronDown size={18} /> : <ChevronRight size={18} />
            ) : (
              <span className="no-toggle"></span>
            )}
          </div>
          <div className="node-info">
            <div className="node-header">
              <span className={`level-badge level-${node.level}`}>L{node.level}</span>
              <span className="node-name">{node.name}</span>
            </div>
            <span className="node-email">{node.email}</span>
          </div>
          <div className="node-stats">
            <div className="stat">
              <Users size={14} />
              <span>{node.totalReferrals} referrals</span>
            </div>
            <div className="stat">
              <DollarSign size={14} />
              <span>{node.totalInvestment}</span>
            </div>
            <div className="stat commission">
              <TrendingUp size={14} />
              <span>{node.commission}</span>
            </div>
          </div>
        </div>
        {isExpanded && hasChildren && (
          <div className="node-children">
            {node.children.map((child) => renderTreeNode(child, depth + 1))}
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="pamm-referral-container">
      {/* Page Header */}
      <div className="page-header">
        <div className="header-left">
          <h1>PAMM Referral Tree</h1>
          <div className="header-bottom">
            <h2 className="view-all">View PAMM referral hierarchy</h2>
          </div>
        </div>
        <div className="header-right">
          <button className="btn">Expand All</button>
          <button className="btn">Collapse All</button>
          <button className="btn orange">Export Data</button>
        </div>
      </div>

      {/* Stats Cards */}
      <div className="stats-row">
        <div className="stat-card">
          <h3>Total Master IBs</h3>
          <p className="stat-value">45</p>
        </div>
        <div className="stat-card">
          <h3>Total Sub IBs</h3>
          <p className="stat-value">128</p>
        </div>
        <div className="stat-card">
          <h3>Total Clients</h3>
          <p className="stat-value">892</p>
        </div>
        <div className="stat-card">
          <h3>Total Commission Paid</h3>
          <p className="stat-value success">$125,000</p>
        </div>
      </div>

      {/* Search */}
      <div className="filters">
        <input type="text" placeholder="Search by Name, Email" />
        <select>
          <option>All Levels</option>
          <option>Level 1 - Master IB</option>
          <option>Level 2 - Sub IB</option>
          <option>Level 3 - Client</option>
        </select>
        <button className="btn">Reset Filters</button>
      </div>

      {/* Tree View */}
      <div className="tree-container">
        {treeData.map((node) => renderTreeNode(node))}
      </div>

      {/* Footer */}
      <footer className="footer">
        <p>Copyright © 2025 <span className="brand">Vista FX Solutions</span>. All rights reserved.</p>
        <span className="version">Version 2.0</span>
      </footer>
    </div>
  );
}

export default PAMMReferralTree;
